import { create } from 'zustand'

import { getUserLeaderboardApi } from '@api'

type WithAvatar = {
  avatar_effect: string
  avatar_icon: string
}

type BaseUser = {
  username: string
  rating: number
  is_premium: boolean
}

export type LeaderboardUser = BaseUser & WithAvatar

export type Me = BaseUser & {
  position: number
  avatar_asset: WithAvatar
}

export type LeaderBoardStore = {
  leaderboard: LeaderboardUser[]
  me: Me
  totalScore: number,
  isLoading: boolean
  error: string | null
  actions: {
    fetchLeaderboard: () => Promise<void>
    fetchingLoop: () => Promise<void>
  }
}

const useLeaderboardStore = create<LeaderBoardStore>((set, get) => ({
  leaderboard: [],
  me: {
    username: '',
    rating: 0,
    position: 0,
    is_premium: false,
    avatar_asset: {
        avatar_effect: '',
        avatar_icon: ''
    }
  },
  totalScore: 0,
  isLoading: false,
  error: null,
  actions: {
    fetchLeaderboard: async () => {
      set({ isLoading: true })
      const { data, ok } = await getUserLeaderboardApi()
      if (ok && data) {
        set({
          leaderboard: data.leaderboard,
          me: data.me,
          totalScore: data.total_score
        })
      }
      
      set({ isLoading: false })
      get().actions.fetchingLoop()
    },
    fetchingLoop: async () => {
      setTimeout(async () => {
          const { data, ok } = await getUserLeaderboardApi()
          if (ok && data) {
            set({
              leaderboard: data.leaderboard,
              me: data.me,
              totalScore: data.total_score
            })
          }
          get().actions.fetchingLoop()
      },60000)
    }
  },
}))

export const useLeaderboardActions = () =>
  useLeaderboardStore((state) => state.actions)
export const useLeaderboardState = () =>
  useLeaderboardStore((state) => ({
    leaderboard: state.leaderboard,
    me: state.me,
    totalScore: state.totalScore,
    isLoading: state.isLoading
  }))
